module.exports = __webpack_public_path__ + "img/ios-beer.0e9275f4.svg";